import React from 'react'
import './css/AboutClientCard.css'

function AboutClientCard({image, name, position}) {
  return (
    <div className='AboutClientCard'>
        <div className='Img'>
            <img src={image} alt={name} />
        </div>
        <div className='content'>
            <h3>{name}</h3>
            <h4>{position}</h4>
        </div>
    </div>
  )
}

export default AboutClientCard